import React from 'react';
import { ProducerSignatureCanvas } from './ProdcucerSignatureCanvas';
import { ProducerSignatureImage } from './ProducerSignatureImage';

export const ProducerSignature = ({ signatureType, edit, ...props }) =>
  edit ? <ProducerSignatureCanvas signatureType={signatureType} {...props} /> : <ProducerSignatureImage {...props} />;
